/* ==========================================================================
 * at-pdp-custom.js
 * 1) Dymki "i" – obsługa kliknięcia/dotyku i klawiatury (hover działa z CSS).
 * 2) Automatyczna dopłata – po dodaniu produktu do koszyka dodaje w tle
 *    "produkty-dopłaty" (Własna metka +3 zł, Zamek +30 zł) w ilości równej
 *    ilości głównego produktu.
 *
 * WYMAGANE (patrz instrukcja): utwórz w Shopify dwa produkty z uchwytami (handle):
 *    doplata-wlasna-metka   – cena 3 zł
 *    doplata-zamek          – cena 30 zł
 * Jeśli produkty nie istnieją, kod nic nie robi (strona działa normalnie).
 * ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Dymki */
  function closeAllTips(except) {
    document.querySelectorAll('.at-tip.is-open').forEach(function (t) {
      if (t !== except) {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var tip = e.target.closest ? e.target.closest('.at-tip') : null;
    closeAllTips(tip);
    if (tip) {
      e.preventDefault();
      var open = tip.classList.toggle('is-open');
      tip.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAllTips(null);
  });

  /* --------- Akordeony + ramka rabatów: PŁYNNE rozwijanie/zwijanie ---------
   * Zdjęcie produktu jest "sticky" i podąża za scrollem. Gdy sekcja obok
   * zmienia wysokość SKOKOWO (natywny <details>), zdjęcie skacze. Dlatego
   * animujemy wysokość treści — reflow jest stopniowy, a zdjęcie płynnie
   * przesuwa się zamiast skakać.
   * --------------------------------------------------------------------- */
  var REDUCE =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ACC_MS = 280;

  function contentOf(det) {
    return det.classList.contains('pdp-discount')
      ? det.querySelector('.pdp-discount__table')
      : det.querySelector('.pdp-acc__content');
  }

  function expandDetails(det) {
    var c = contentOf(det);
    det.open = true;
    if (!c || REDUCE) return;
    det.dataset.anim = '1';
    var end = c.scrollHeight;
    c.style.overflow = 'hidden';
    c.style.height = '0px';
    void c.offsetHeight; // wymuś reflow, by animacja wystartowała od 0
    c.style.transition = 'height ' + ACC_MS + 'ms ease';
    c.style.height = end + 'px';
    var done = function (e) {
      if (e && (e.target !== c || e.propertyName !== 'height')) return;
      c.style.transition = '';
      c.style.height = '';
      c.style.overflow = '';
      delete det.dataset.anim;
      c.removeEventListener('transitionend', done);
    };
    c.addEventListener('transitionend', done);
  }

  function collapseDetails(det) {
    var c = contentOf(det);
    if (!c || REDUCE) {
      det.open = false;
      return;
    }
    det.dataset.anim = '1';
    c.style.overflow = 'hidden';
    c.style.height = c.scrollHeight + 'px';
    void c.offsetHeight;
    c.style.transition = 'height ' + ACC_MS + 'ms ease';
    c.style.height = '0px';
    var done = function (e) {
      if (e && (e.target !== c || e.propertyName !== 'height')) return;
      c.style.transition = '';
      c.style.height = '';
      c.style.overflow = '';
      det.open = false;
      delete det.dataset.anim;
      c.removeEventListener('transitionend', done);
    };
    c.addEventListener('transitionend', done);
  }

  function initAccordions() {
    document.querySelectorAll('.pdp-acc, .pdp-discount').forEach(function (det) {
      if (det.__pdpAcc) return;
      det.__pdpAcc = true;
      var summary = det.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (det.dataset.anim) return;
        if (det.open) {
          collapseDetails(det);
          return;
        }
        // single-open: otwarcie jednego akordeonu płynnie zamyka pozostałe
        if (det.classList.contains('pdp-acc')) {
          document.querySelectorAll('.pdp-acc[open]').forEach(function (o) {
            if (o !== det && !o.dataset.anim) collapseDetails(o);
          });
        }
        expandDetails(det);
      });
    });
  }
  initAccordions();
  document.addEventListener('shopify:section:load', initAccordions);

  /* ------------------------------------------------------ Dopłaty (add-ons) */
  var ROOT = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var ADD_URL = (ROOT.replace(/\/$/, '')) + '/cart/add.js';
  var processing = false;

  // Zbiera zaznaczone dopłaty ("Tak") w obrębie danego formularza dodawania do koszyka.
  function collectAddons(form) {
    var scope =
      (form && (form.closest('.product') || form.closest('[id^="MainProduct-"]'))) ||
      document;
    var plan = [];
    scope.querySelectorAll('[data-addon][data-addon-variant]').forEach(function (grp) {
      var variantId = grp.getAttribute('data-addon-variant');
      var yes = grp.querySelector('[data-addon-yes]');
      if (variantId && /^\d+$/.test(variantId) && yes && yes.checked) {
        plan.push({
          id: parseInt(variantId, 10),
          label: grp.getAttribute('data-addon-label') || ''
        });
      }
    });
    return plan;
  }

  function readQuantity(form) {
    var q = form ? form.querySelector('[name="quantity"]') : null;
    var val = q ? parseInt(q.value, 10) : 1;
    return val > 0 ? val : 1;
  }

  function refreshCart() {
    // Best-effort: odśwież koszyk/drawer w motywie. Jeśli się nie uda,
    // dopłaty i tak są w koszyku i będą widoczne na stronie /cart oraz w kasie.
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
    } catch (err) {
      /* no-op */
    }
  }

  function addAddons(plan, quantity, mainProductTitle) {
    if (!plan.length) return;
    var items = plan.map(function (a) {
      return {
        id: a.id,
        quantity: quantity,
        properties: { _dopłata_do: mainProductTitle || '' }
      };
    });
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function () { refreshCart(); })
      .catch(function () { /* nie blokujemy głównego dodania */ })
      .finally(function () { processing = false; });
  }

  // Nasłuch na wysłanie formularza dodawania do koszyka. NIE blokujemy
  // domyślnego działania motywu – dodajemy dopłaty równolegle, w tle.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (processing) return;

      var plan = collectAddons(form);
      if (!plan.length) return;

      processing = true;
      var quantity = readQuantity(form);
      var titleEl = document.querySelector('.product__title');
      var title = titleEl ? titleEl.textContent.trim() : '';

      // Krótkie opóźnienie, aby główne dodanie ruszyło pierwsze.
      setTimeout(function () { addAddons(plan, quantity, title); }, 350);
    },
    true // faza przechwytywania – łapiemy zanim motyw wywoła preventDefault
  );
})();
